export const periodProps = {
  value: {
    type: Object,
    default: () => {
      return {
        startTime: '',
        endTime: '',
        permanentSet: false
      }
    }
  },
  // 起始和结束时间格式 'yyyy-MM' 'yyyy-MM-dd' 'yyyy-MM-dd HH:mm' 'yyyy-MM-dd HH:mm:ss'
  dateFormat: {
    type: String,
    default: '',
    require: true
  },
  // 是否显示永久配置项
  isPermanent: {
    type: Boolean,
    default: true
  },
  // 起止时间叹号提示
  tip: {
    type: String,
    default: '',
    require: true
  },
  // 是否永久
  permanentSet: {
    type: Boolean,
    default: true
  },
  // 是否显示清除按钮
  clearable: {
    type: Boolean,
    default: true
  },
  // 是否只读
  disabled: {
    type: Boolean,
    default: false
  },
  // title
  name: {
    type: String,
    default: ''
  },
  // 调整尺寸
  size: {
    type: String,
    default: 'small'
  },
  // 纯文本
  isPureText: {
    type: Boolean,
    default: true
  }
}